import React from "react"
import { DataGrid } from "@mui/x-data-grid"
import { Typography } from "@mui/material"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import { useGetPurchaseDSQuery } from "../../../core/api/ds-analytical-data-api"
import Loading from "../../../components/Common/Loading"

dayjs.extend(utc)

const WINDOW_MS = 60 * 60 * 1000

const COLUMNS = [
    {
        headerName: "ID",
        field: "id",
        width: 100
    },
    {
        headerName: "Timestamp",
        field: "timestamp",
        width: 200,
        valueGetter: (value) => value != null ? dayjs.utc(value).format("DD.MM.YYYY HH:mm:ss.SSS") : "-"
    },
    {
        headerName: "Payload",
        field: "payload",
        flex: 1
    },
    {
        headerName: "Source",
        field: "source",
        flex: 1
    },
    {
        headerName: "Item ID",
        field: "itemId",
        flex: 1
    },
    {
        headerName: "Item Name",
        field: "itemName",
        flex: 1
    },
    {
        headerName: "Amount",
        field: "amount",
        flex: 1
    },
    {
        headerName: "Status",
        field: "status",
        flex: 1
    },
    {
        headerName: "Period",
        field: "period",
        flex: 1
    }
]

const DSPurchaseItem = (props) => {
    const from = dayjs.utc(props.date).toISOString()
    const to = dayjs.utc(props.date).add(WINDOW_MS, "millisecond").toISOString()

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        isFetching,
        error
    } = useGetPurchaseDSQuery({
        userId: props.deviceId,
        payload: props.payload,
        from,
        to,
        limit: 100
    })

    let payments = ""

    if (typeof data === "object") {
        payments = <DataGrid
            getRowId={(row) => row.id}
            rows={data}
            columns={COLUMNS}
            pageSize={100}
            rowsPerPageOptions={[100]}
            autoHeight
        />
    } else {
        payments = "no data"
    }

    return (
        <Loading
            isLoading={isLoading || isFetching}
            isError={isError}
            error={error}
            isSuccess={isSuccess}
        >
            <Typography variant="body2" component="div" sx={{ mb: 1, fontFamily: "monospace", whiteSpace: "pre-wrap" }}>
                {`Payload: ${props.payload ?? "-"}\nFrom: ${from}\nTo: ${to}`}
            </Typography>
            {payments}
        </Loading>
    )
}

export default DSPurchaseItem
